import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class Planque extends ActionCard {
    static typeId = "PLANQUE";
    static cardName = "Planqué";
    static colorHex = "#FFAA00";
    static countInDeck = ACTION_CARD_COUNTS.PLANQUE;
    static description = "Protégez un mouton jusqu’à votre prochain tour.";

    isValidOn(slotIndex, gameState) {
        const lineActor = gameState.lineOfFire[slotIndex];
        return lineActor.isDuck && !gameState.slotIsProtected(slotIndex);
    }

    resolve(slotIndex, gameState) {
        gameState.planque(slotIndex);
    }
}
